import request from '../utils/request';

// 获取网络类型
export const getNetworkType = () => {
  const conn = navigator.connection;
  if (conn) {
    // 1. 优先使用 type 字段（部分浏览器直接提供 wifi/cellular 等类型）
    if (conn.type) {
      const typeMap = {
        'wifi': 'wifi',
        'cellular': 'cellular',
        'ethernet': 'ethernet',
        'bluetooth': 'bluetooth',
        'none': 'none',
        'other': 'other',
        'unknown': 'unknown'
      };
      const t = typeMap[conn.type] || conn.type;
      
      // 如果是蜂窝网络，再用 effectiveType 判断 4G/5G
      if (t === 'cellular' && conn.effectiveType) {
        const et = conn.effectiveType;
        if (et === '4g') {
          // 4g effectiveType 下的高网速可能是5G
          if (conn.downlink && conn.downlink >= 10) return '5g';
          return '4g';
        }
        return et; // 3g, 2g, slow-2g
      }
      return t;
    }
    
    // 2. 只有 effectiveType（Chrome等浏览器）
    if (conn.effectiveType) {
      const et = conn.effectiveType;
      if (et === '4g') {
        // 4g effectiveType 在非蜂窝网络下通常是WiFi
        // downlink较高且rtt较低更可能是WiFi
        const downlink = conn.downlink || 0;
        const rtt = conn.rtt || 0;
        // WiFi特征：低延迟、高带宽
        if (rtt < 50 && downlink > 2) return 'wifi';
        // 5G特征：低延迟、高带宽
        if (downlink >= 10) return '5g';
        return '4g';
      }
      return et; // 3g, 2g
    }
    
    // 3. 通过 RTT 降级猜测
    if (conn.rtt !== undefined) {
      const rtt = conn.rtt;
      if (rtt === 0) return 'wifi';
      if (rtt < 50) return 'wifi';
      if (rtt < 100) return '5g';
      if (rtt < 200) return '4g';
      return '3g';
    }
  }
  
  return 'unknown';
};

// 登录
export const login = (employee_id, password, networkType) => {
  return request.post('/auth/login', { employee_id, password, network_type: networkType });
};

// 验证登录状态
export const verifyToken = () => {
  return request.get('/auth/verify');
};
